// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m13.802 3.867 1.676 1.383V4.5c0-.276.215-.5.48-.5h.96a.49.49 0 0 1 .48.5v2.335l3.653 3.014a.514.514 0 0 1 .086.692l-.6.833a.468.468 0 0 1-.684.09l-.535-.445v7.068c0 1.657-1.29 3-2.88 3H6.838c-1.59 0-2.88-1.343-2.88-3v-7.068l-.536.446a.468.468 0 0 1-.683-.09l-.6-.834a.514.514 0 0 1 .085-.692l7.25-5.982.377-.306a2.79 2.79 0 0 1 3.575 0l.374.309zM5.878 9.871v8.216c0 .552.43 1 .96 1h2.88V14.5c0-.276.215-.5.48-.5h2.88a.49.49 0 0 1 .48.5v4.587h2.88c.53 0 .96-.448.96-1V9.87c0-.23-.076-.45-.211-.625l-4.953-4.117a.93.93 0 0 0-1.192 0L6.091 9.244a1.026 1.026 0 0 0-.213.627z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationHome;
